import logic from "src/utils/genLogic";
import { ActionTypes } from "./actions";
import { Trans } from "@lingui/react";

const apiNamespace = "reportsResponses";

const addCustomReportLogic = logic(apiNamespace, {
  actionName: ActionTypes.ADD_CUSTOM_REPORT,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_added_successfully" />,
});
const getCustomReportLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_CUSTOM_REPORT,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
});
const getCustomExcelReportLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_CUSTOM_EXCEL_REPORT,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
});

export default [
  addCustomReportLogic,
  getCustomReportLogic,
  getCustomExcelReportLogic,
];
